import * as ActionTypes from '../Expand';

export function expandAllGroups(data) {
    return {type: ActionTypes.EXPAND_ALL_GROUPS, data, section: 'live'};
}

export function expandAllMatches(data) {
    return {type: ActionTypes.EXPAND_ALL_MATCHES, data, section: 'live'};
}



// WEBPACK FOOTER //
// ./js/actions/creators/Expand.js